import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getEmpresaTransportista`, method: 'GET', body: null, token: token})
}